module.exports = __webpack_public_path__ + "media/SetB_T1_A.4a152157.mp3";